import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getRepairOrderReadOnly = () => makeRequest(authFetch.get('/api/repairOrders/ReadOnly'));

export const getRepairOrders = async (params) => makeRequest(
  authFetch.get(`/api/repairOrders${getQueryParams(params)}`),
);

export const getRepairOrdersForExport = (params) => makeRequest(
  authFetch.get(`/api/RepairOrders/Export${getQueryParams({
    ...params,
    page: 1,
    pageSize: 9999,
  })}`),
);

export const getRepairOrder = async (orderId) => {
  if (!orderId === null || orderId === undefined) {
    return Promise.resolve(null);
  }

  try {
    const response = await authFetch.get(`/api/repairOrders/${orderId}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const putRepairOrder = (repairOrder) => makeRequest(authFetch.put('/api/repairOrders', repairOrder));
export const deleteRepairOrder = (id) => makeRequest(authFetch.delete(`/api/repairOrders/${id}`));
export const restoreRepairOrder = (id) => makeRequest(authFetch.patch(`/api/repairOrders/${id}/restore`));

export const reOpenRepairOrder = (id) => makeRequest(authFetch.patch(`/api/repairOrders/${id}/reopen`));

export const getRepairOrderAudits = (id, params) => makeRequest(
  authFetch.get(`/api/repairOrders/${id}/Audits${getQueryParams(params)}`),
);

export const getRepairOrderAuditProperties = (id) => makeRequest(
  authFetch.get(`/api/repairOrders/${id}/Audits/Properties`),
);
export const getRepairOrderAuditUsers = (id) => makeRequest(authFetch.get(`/api/repairOrders/${id}/Audits/Users`));

export const getRepairOrderFiles = async (repairOrderId, params) => makeRequest(
  authFetch.get(`/api/repairOrders/${repairOrderId}/Files${getQueryParams(params)}`),
);

export const postRepairOrderFiles = (repairOrderId, files) => makeRequest(
  authFetch.post(`/api/repairOrders/${repairOrderId}/Files`, files),
);

export const updateRepairOrderFileInfo = async (repairOrderId, fileId, info) => {
  try {
    const response = await authFetch.put(`/api/repairOrders/${repairOrderId}/Files/${fileId}`, info);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteRepairOrderFile = (repairOrderId, fileId) => makeRequest(
  authFetch.delete(`/api/repairOrders/${repairOrderId}/Files/${fileId}`),
);

export const getRepairOrderReportedByTypes = async () => {
  try {
    const response = await authFetch.get('/api/repairOrders/ReportedByTypes');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRepairOrderStatuses = async () => {
  try {
    const response = await authFetch.get('/api/repairOrders/RepairOrderStatuses');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRepairOrderItems = async () => {
  try {
    const response = await authFetch.get('/api/repairOrders/RepairOrderItems');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRepairOrderDocumentTypes = () => makeRequest(authFetch.get('/api/repairOrders/DocumentTypes'));

export const getRepairOrderNotes = async (id, data) => makeRequest(
  authFetch.get(`/api/repairOrders/${id}/Notes${getQueryParams(data)}`),
);

export const postRepairOrderNote = async (id, note) => makeRequest(
  authFetch.post(`/api/repairOrders/${id}/Notes`, note),
);

export const getRepairTypesLookup = () => makeRequest(authFetch.get('/api/RepairOrders/RepairTypes/Lookup'));

export const getRepairOrderCategories = () => makeRequest(authFetch.get('/api/repairOrders/RepairOrderCategories'));
export const getRepairOrderIssues = () => makeRequest(authFetch.get('/api/repairOrders/RepairOrderIssues'));

export const getRepairOrderTireSizes = (repairOrderId, params) => makeRequest(
  authFetch.get(`/api/repairOrders/${repairOrderId}/TireSizes${getQueryParams(params)}`),
);

export const getRepairLocationTypes = () => makeRequest(authFetch.get('/api/repairOrders/LocationTypes'));

export const upsertTireSize = (repairOrderId, tireSize) => makeRequest(
  authFetch.put(`/api/repairOrders/${repairOrderId}/TireSizes`, tireSize),
);

export const deleteRepairOrderTireDetails = (repairOrderId, id) => makeRequest(
  authFetch.delete(`/api/repairOrders/${repairOrderId}/TireSizes/${id}`),
);

export const updateRepairOrderStatusStatus = (repairOrderId, status) => makeRequest(
  authFetch.put(`/api/repairOrders/${repairOrderId}/Status`, status),
);

export const getOrderDetailsByPro = (proNumber) => makeRequest(
  authFetch.get(`api/RepairOrders/orderDetails/${proNumber}`),
);
